// extracted by mini-css-extract-plugin
export default {"kpiUpdate":"KPIUpdateIndicator_kpiUpdate__lRBZV","requiredIcon":"KPIUpdateIndicator_requiredIcon__R5Eba","updatedIcon":"KPIUpdateIndicator_updatedIcon__AfiK+"};